@if (ready) {
  <highcharts-chart
    id="container"
    [Highcharts]="Highcharts"
    [constructorType]="chartConstructor"
    [options]="chartOptions"
    [callbackFunction]="chartCallback"
    [(update)]="updateFlag">
    <!--  style="display: block; height: 100%; width: 100%">-->
  </highcharts-chart>
}
